import React from 'react'
import "./hot.css"
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HashLink as Link } from 'react-router-hash-link';
const Hot = (props) => {

    function copyText(entryText){
        navigator.clipboard.writeText(entryText);
        toast.success('🦄 Successfully copied to clipboard!', {
            theme: "dark",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });

      }
    return (
        <div>
            <Link to={`/products/#${props.id}`}>
                <div className="box">
                    <div className="icons">
                    <Link to="#_" onClick={() => props.OnAddToCart(props.id, 1)} href="#_" className="fas fa-shopping-cart"></Link>
                    <Link to={`/products/#${props.id}`} className="fas fa-eye"></Link>
                    <Link to="#_" onClick={() => copyText(`https://halloweencommerce.netlify.app/products/#${props.id}`)} className="fas fa-share"></Link>
                    </div>
                    <div className="image">
                        <img src={props.imageurl} alt="" />
                    </div>
                    <div className="content">
                        <h3>{props.name}</h3>
                        <div className="price">${props.price_after_discount} <span>${props.price_before_discount} </span></div>
                    </div>
                </div>
            </Link>
      <ToastContainer />

        </div>
    )
}

export default Hot
